import React, { FC, useState } from 'react'
import { default as ReactLightbox } from 'react-image-lightbox'
import { ImageSrcI } from '../../custom-hooks/useLayoutConfig'
import { withPrefix } from 'gatsby'

interface LightBoxPropsI {
  allImages: ImageSrcI[]
  currentIndex: number
  onClose: () => void
}

const Lightbox: FC<LightBoxPropsI> = ({ allImages, currentIndex, onClose }: LightBoxPropsI) => {
  const [current, setCurrent] = useState(currentIndex)
  const handleNext = (): void => setCurrent((current + 1) % allImages.length)
  const handlePrev = (): void => setCurrent((current + allImages.length - 1) % allImages.length)

  return (
    <ReactLightbox
      mainSrc={withPrefix(allImages[current].sm)}
      mainSrcThumbnail={withPrefix(allImages[current].thumb)}
      onCloseRequest={onClose}
      nextSrc={current < allImages.length - 1 ? withPrefix(allImages[current + 1].sm) : undefined}
      nextSrcThumbnail={current < allImages.length - 1 ? withPrefix(allImages[current + 1].thumb) : undefined}
      prevSrc={current > 0 ? withPrefix(allImages[current - 1].sm) : undefined}
      prevSrcThumbnail={current > 0 ? withPrefix(allImages[current - 1].thumb) : undefined}
      onMoveNextRequest={handleNext}
      onMovePrevRequest={handlePrev}
    />
  )
}

export default Lightbox

// configuration for rotating prev and next values
// return (
//   <ReactLightbox
//     mainSrc={withPrefix(allImages[current].sm)}
//     mainSrcThumbnail={withPrefix(allImages[current].thumb)}
//     onCloseRequest={onClose}
//     nextSrc={withPrefix(allImages[(current + 1) % allImages.length].sm)}
//     nextSrcThumbnail={withPrefix(allImages[(current + 1) % allImages.length].thumb)}
//     prevSrc={withPrefix(allImages[(current + allImages.length - 1) % allImages.length].sm)}
//     prevSrcThumbnail={withPrefix(allImages[(current + allImages.length - 1) % allImages.length].thumb)}
//     onMoveNextRequest={handleNext}
//     onMovePrevRequest={handlePrev}
//   />
// )
